import { render, staticRenderFns } from "./TableFooter.vue?vue&type=template&id=ed053b92&scoped=true"
import script from "./TableFooter.ts?vue&type=script&lang=ts&external"
export * from "./TableFooter.ts?vue&type=script&lang=ts&external"
import style0 from "./TableFooter.scss?vue&type=style&index=0&id=ed053b92&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed053b92",
  null
  
)

export default component.exports